import { GameCategory } from '../enums';

export const ErrorPrefix = {
  [GameCategory.BOG]: 'TB',
  [GameCategory.TableGames]: 'TB',
  [GameCategory.Slot]: 'S',
  [GameCategory.TronixZone]: 'S',
  [GameCategory.Arcade]: 'A',
  [GameCategory.CryptoGames]: 'C',
  Platform: 'P'
};
